import viewerPosition from '../assets/brand/viewer-position.png'

export function ViewerPositionIcon() {
  return <img className="viewer-position-icon" src={viewerPosition} alt="" aria-hidden="true" />
}
